export const DEFAULT_FORM_FIELD_MARGIN_BOTTOM_IN_PX = 24

export const MY_PAGE_PREVIEW_ZINDEX = 105
